import { useState, useEffect } from 'react';
import api from './api';
import { useAuth } from './AuthContext';

export function Calendar() {
    const today = new Date();
    const [year, setYear] = useState(today.getFullYear());
    const [month, setMonth] = useState(today.getMonth() + 1);
    const [events, setEvents] = useState([]);
    const [expandedDay, setExpandedDay] = useState(null);
    const [dayMessages, setDayMessages] = useState([]);
    const [newTitle, setNewTitle] = useState('');
    const [newDesc, setNewDesc] = useState('');
    const [newDate, setNewDate] = useState('');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const load = () => {
        api.get(`/calendar?year=${year}&month=${month}`).then((res) => setEvents(res.data));
    };

    useEffect(() => { load(); }, [year, month]);

    const daysInMonth = new Date(year, month, 0).getDate();
    const firstDayOfWeek = new Date(year, month - 1, 1).getDay();

    const prevMonth = () => {
        if (month === 1) { setMonth(12); setYear(year - 1); } else setMonth(month - 1);
    };
    const nextMonth = () => {
        if (month === 12) { setMonth(1); setYear(year + 1); } else setMonth(month + 1);
    };

    const eventsForDay = (day) => {
        const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        return events.filter((e) => e.event_date.startsWith(dateStr));
    };

    const expandDay = async (day) => {
        const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        if (expandedDay === day) { setExpandedDay(null); return; }
        setExpandedDay(day);
        const res = await api.get(`/calendar/${dateStr}/messages`);
        setDayMessages(res.data);
    };

    const addEvent = async (e) => {
        e.preventDefault();
        if (!newTitle || !newDate) return;
        await api.post('/calendar', { title: newTitle, description: newDesc, event_date: newDate });
        setNewTitle(''); setNewDesc(''); setNewDate('');
        load();
    };

    const deleteEvent = async (id) => {
        await api.delete(`/calendar/${id}`);
        load();
    };

    const cells = [];
    for (let i = 0; i < firstDayOfWeek; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(d);

    return (
        <div className="calendar-page">
            <div className="calendar-header">
                <button onClick={prevMonth}>&lt;</button>
                <h2>{year}-{String(month).padStart(2, '0')}</h2>
                <button onClick={nextMonth}>&gt;</button>
            </div>

            {isAdmin && (
                <form onSubmit={addEvent} className="add-event-form">
                    <input type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
                    <input placeholder="Title" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} />
                    <input placeholder="Description" value={newDesc} onChange={(e) => setNewDesc(e.target.value)} />
                    <button type="submit">Add Event</button>
                </form>
            )}

            <div className="calendar-grid">
                {cells.map((day, i) => (
                    <div key={i} className={`calendar-cell ${day ? 'active' : 'empty'}`}>
                        {day && (
                            <>
                                <div className="day-number" onClick={() => expandDay(day)}>{day}</div>
                                {eventsForDay(day).map((ev) => (
                                    <div key={ev.id} className="calendar-event">
                                        {ev.title}
                                        {isAdmin && <button onClick={() => deleteEvent(ev.id)}>x</button>}
                                    </div>
                                ))}
                                {expandedDay === day && (
                                    <div className="day-messages">
                                        <strong>Messages:</strong>
                                        {dayMessages.length === 0 && <p>No messages</p>}
                                        {dayMessages.map((m) => (
                                            <div key={m.id} className="day-message">{m.content}</div>
                                        ))}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
